import { Link } from "react-router-dom";

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/generate" aria-label="GAMEFRAME 首页">
      <img
        className="brand-logo"
        src="/brand/kook-logo.png"
        alt=""
        width="153"
        height="43"
      />
      {!compact && <span className="brand-name">GAMEFRAME</span>}
    </Link>
  );
}
